import api from "../config/api";


export const getQuotations = async (data) => {
  const res = await api.get("quotations", data);
  return res.data;
};

export const getQuotationByid = async ({ _id }) => {
  const res = await api.get(`quotations/${_id}`);
  return res.data;
};
